module.exports = __webpack_public_path__ + "static/img/czdj.02a8eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/czdj.png
// module id = Mztw
// module chunks = 2